import { createSlice } from "@reduxjs/toolkit";

import { getDockrestrictionReportData, addDockrestrictionReportData } from "../thunks/dockRestrictionThunk";

interface DockRestrictionListState {
  addRestriction: any[];
  dockRestrictionSuccess:any;
  loading: boolean;
  error: string | null;
};

const initialState: DockRestrictionListState = {
    addRestriction: [],
    dockRestrictionSuccess:null,
    loading: false,
    error: null,
};

export const dockRestrictionSlices = createSlice({
  name: "dockRestriction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDockrestrictionReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDockrestrictionReportData.fulfilled, (state, action) => {
        state.dockRestrictionSuccess = action.payload;
        state.loading = false;
      })
      .addCase(getDockrestrictionReportData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(addDockrestrictionReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDockrestrictionReportData.fulfilled, (state, action) => {
        // state.addRestriction = action.payload || [];
        state.loading = false;
      })
      .addCase(addDockrestrictionReportData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export default dockRestrictionSlices.reducer;